module.exports = __webpack_public_path__ + "img/logo_cnp_seguradora.74b32a1f.svg";